/** @format */
import { Link } from 'react-router-dom';

const Error404 = () => {
	return (
		<>
			<div className='d-flex flex-column align-items-center vh-100'>
				<h1 className='text-center text-danger my-3'>کد خطا: 404</h1>
				<h5 className='text-center text-secondary my-3'>
					صفحه درخواستی شما وجود ندارد.
				</h5>
				<Link to='/' className='btn btn-info btn-sm text-white mb-3'>
					بازگشت به سایت
				</Link>
			</div>
		</>
	);
};
export default Error404;
